/** The gleam (`.igw-gleam`, `igw-button.css`): a hot band sweeping a
 *  surface's rim and a broad slanted sheen crossing its face — the top
 *  prize's cell, a missions task won. Placed over its surface (which must
 *  be positioned); its pace, count and shape come from the class's
 *  variables. The caller leaves it out under reduced motion. */
export function Gleam({
  variant,
  face,
}: {
  variant?: string;
  /** The face's sheen alone, no rim band: for a surface whose shape isn't
   *  its box (a prize drop's slanted slab, clipped). */
  face?: boolean;
}) {
  const mod = variant ? ` igw-gleam--${variant}` : "";
  return (
    <>
      <span className={`igw-gleam igw-gleam--face${mod}`} aria-hidden="true" />
      {!face && (
        <span className={`igw-gleam igw-gleam--rim${mod}`} aria-hidden="true" />
      )}
    </>
  );
}
